import React from "react";
import { Link, useNavigate } from "react-router-dom";
import SecondaryButton from "../../components/SecondaryButton";
import { Button, Snackbar, Breadcrumbs } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { Policy } from "../../objects/policy";
import { useEffect, useState } from "react";
import ReviewDriversList from "../../components/review/ReviewDriversList";
import ReviewVehiclesList from "../../components/review/ReviewVehiclesList";
import { RatingResponse } from "../../objects/rating";
import { QuoteService } from "../../services/quoteservice";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from "@mui/material/Alert";
import dayjs, { Dayjs } from 'dayjs';
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { RatingService } from "../../services/ratingservice";
import { SystemFlags } from "../../objects/systemFlags";
import ProcessingModal from "../../components/modals/ProcessingModal";
import { logActivityAsync } from "../../objects/events/loadEvents";
import JsonService from "../../services/jsonService";

function Review() {
    var navigate = useNavigate();
    var quoteService = new QuoteService();
    var ratingService = new RatingService();

    var policyStore = useSelector((state: any) => state.policyReducer as Policy);
    var ratedPolicyStore = useSelector((state: any) => state.ratedPolicyReducer as RatingResponse);
    const systemFlags = useSelector((state: any) => state.systemFlagsPolicyReducer) as SystemFlags;
    
    const [policy, setPolicy] = useState<Policy>(new Policy());
    const [ratedQuote, setRatedQuote] = useState<RatingResponse>(new RatingResponse());
    const [isEditEffectiveDate, setIsEditEffectiveDate] = useState<boolean>(false);
    const [isRating, setIsRating] = useState(true);

    const [effectiveDate, setEffectiveDate] = useState<Dayjs | null>(null);
    const [newEffectiveDate, setNewEffectiveDate] = useState<Dayjs | null>(null);
    const [isReload, setIsReload] = useState(false);

    const [isPageLoad, setIsPageLoad] = useState(true);
    const [isBelowMinimum, setIsBelowMinimum] = useState<boolean>(false);
    const [isBeyondMaximum, setIsBeyondMaximum] = useState<boolean>(false);
    const dispatch = useDispatch();

    useEffect(() => {
        (async () => {
            await logActivityAsync(policy?.policyNumber ?? "", {
                recordKey: policy?.policyNumber,
                transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                action: "add_activity",
                subject: "Navigation",
                message: "Insured has navigated to the review screen",
                isException: false,
                error: "",
                level: "INFO",
                isSent: false
            });
        })();
    }, []);

    useEffect(() => {
        if (policyStore === null || policyStore === undefined) {
            navigate("/" + window.location.search)
        }

        (async () => {

            if (isPageLoad) {
                setOpen(true);
                setIsRating(true);

                window.scrollTo(0, 0);

                for (let car of policyStore.vehicles) {
                    var flag = car.flags.find(m => m.name === "MonitoringEnabled");
                }

                var rateResult = await ratingService.Rate(policyStore);

                if (!rateResult.ok) {
                    var queryParams = new URLSearchParams(window.location.search);
                    queryParams.set("returnUrl", "/review");
                    var rateError = JsonService.parseObject(await rateResult.text());

                    await logActivityAsync(policyStore?.policyNumber ?? "", {
                        recordKey: policyStore?.policyNumber,
                        transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                        action: "error_activity",
                        subject: "Review - Rating Error",
                        message: `Quote# ${policyStore.policyNumber} - ${policyStore.insuredFirstName} ${policyStore.insuredLastName}, ${policyStore.emailAddress}`,
                        isException: true,
                        error: rateError?.message ?? "Empty Response",
                        level: "ERROR",
                        isSent: false
                    });

                    navigate("/error?" + queryParams.toString());
                    setIsRating(false);

                    return;
                }

                var data = await rateResult.json();
                var pclone = { ...policyStore };
                pclone.policyNumber = data.policyNumber;


                setIsReload(false);
                var quote = await quoteService.serialize(pclone.policyNumber);

                if (!quote.ok) {
                    await logActivityAsync(policyStore?.policyNumber ?? "", {
                        recordKey: policyStore?.policyNumber,
                        transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                        action: "error_activity",
                        subject: "Review - Serialize Error",
                        message: `Quote# ${policyStore.policyNumber} - ${policyStore.insuredFirstName} ${policyStore.insuredLastName}, ${policyStore.emailAddress}`,
                        isException: true,
                        error: quote?.error?.message ?? "Empty Response",
                        level: "ERROR",
                        isSent: false
                    });

                    var queryParams = new URLSearchParams(window.location.search);
                    queryParams.set("returnUrl", "/");
                    navigate("/error?" + queryParams.toString());

                    return;
                }

                var ratedData = data as RatingResponse;

                //TODO: 100 should be a setting in .env file
                if (ratedData.totalWritten < 100) {
                    setIsBelowMinimum(true);
                }

                if (ratedData.totalWritten > 6000 && quote.data?.vehicles.length == 1 && quote.data.drivers.length == 1) {
                    setIsBeyondMaximum(true);
                }

                for (let car of (quote.data?.vehicles ?? [])) {
                    var flag = car.flags.find(m => m.name === "MonitoringEnabled");
                }


                dispatch({ type: "RATE_QUOTE", payload: data })
                dispatch({ type: "UPDATE", payload: quote.data })

                setPolicy((quote.data) as Policy);
                setRatedQuote(data);

                setEffectiveDate(dayjs(quote.data?.effectiveDate));
                setOpen(false);

                setIsRating(false);
                setIsPageLoad(false);
            }
        })();
    }, [])

    const [open, setOpen] = React.useState(false);
    const [isOpenErrorAlert, setIsOpenErrorAlert] = React.useState(false);

    const currencyFormatter = new Intl.NumberFormat('en-US',
        {
            style: 'currency',
            currency: 'USD'
        });

    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };

    const handleErrorAlertClose = () => {
        setIsOpenErrorAlert(false);
    };

    const handleErrorAlertOpen = () => {
        setIsOpenErrorAlert(true);
    };

    function NavigateBack() {
        navigate("/people" + window.location.search)
    }

    function onPurchasePolicy() {
        navigate("/questions" + window.location.search)
    }

    async function onSaveEffectiveDate() {
        (async () => {
            setIsReload(true);
            var pclone = { ...policy };
            pclone.effectiveDate = dayjs(newEffectiveDate).toDate().toDateString();

            var response = await ratingService.Rate(pclone);

            if (!response.ok) {
                var rateError = JsonService.parseObject(await response.text());
                await logActivityAsync(pclone?.policyNumber ?? "", {
                    recordKey: pclone?.policyNumber,
                    transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                    action: "error_activity",
                    subject: "Review - Serialize Error",
                    message: `Quote# ${pclone.policyNumber} - ${pclone.insuredFirstName} ${pclone.insuredLastName}, ${pclone.emailAddress}`,
                    isException: true,
                    error: rateError?.error?.message ?? "Empty Response",
                    level: "ERROR",
                    isSent: false
                });

                return;
            }
            var data = await response.json();

            pclone.policyNumber = data.policyNumber;

            dispatch({ type: "RATE_QUOTE", payload: data })
            dispatch({ type: "UPDATE", payload: pclone })

            setPolicy(pclone);
            setRatedQuote(data);
            setEffectiveDate(dayjs(pclone.effectiveDate));

            navigate("/review" + window.location.search);

            setIsEditEffectiveDate(false);
            setIsReload(false);

        })();
    }

    function onCancelChangeEffectiveDate(e: any) {
        setIsEditEffectiveDate(false);
    }

    function disablePriorDates(date: Dayjs) {
        var now = new Date();
        var futureDate = new Date();

        now.setDate(new Date().getDate() - 1);
        futureDate.setDate(new Date().getDate() + 30);

        var isInPast = date.toDate() < now || date.toDate() > futureDate;

        return isInPast;
    }

    function renderEffectiveDate() {

        if (isEditEffectiveDate) {

            return <div className="w-full">

                <LocalizationProvider dateAdapter={AdapterDayjs}>

                    <DatePicker
                        label="Policy Start Date"
                        value={effectiveDate}
                        shouldDisableDate={disablePriorDates}
                        className="w-52"
                        onChange={(e) => {
                            setNewEffectiveDate(e)
                        }
                        } />

                </LocalizationProvider>
                <div className="clear-both" />
                <div className="w-52 float-left">
                    <span className="pt-3 float-left text-left block  text-red-600 hover:underline hover:cursor-pointer" onClick={onCancelChangeEffectiveDate}>Cancel</span>
                    <span className=" float-right pl-4 pt-3 text-right block  text-blue-600 hover:underline hover:cursor-pointer" onClick={onSaveEffectiveDate}>{isReload ? <CircularProgress size={"1.3rem"} color="inherit" /> : "Save"}</span>
                </div>
            </div>
        } else {
            return <span>
                {effectiveDate?.toDate().toLocaleDateString()}
            </span>;
        }
    }

    function renderPremiumInfo() {
        if (isBelowMinimum) {
            return <>
                <div className="w-9/12 bg-[#CFE2FF] p-5 rounded-md">
                    <h3 className="font-bold">
                        We are sorry.
                    </h3>
                    <p className="pt-4">
                        This policy does not meet our underwriting guidelines and is ineligible for coverage with Alset
                    </p>
                </div>
            </>;
        }

        if (isBeyondMaximum) {
            return <>
                <div className="w-9/12 bg-[#CFE2FF] p-5 rounded-md">
                    <p className="">
                        You have qualified for concierge services please call 888-270-0025
                    </p>
                </div>
            </>;
        }


        return <>
            <h3 className="font-bold text-xl">Your {ratedQuote.installments.length}-month premium</h3>
            <span className="">{isRating || isBelowMinimum ? "" : currencyFormatter.format(ratedQuote.totalWritten)}</span>
            <br />

            <div className="pt-16 w-9/12 h-10 pb-10">
                <h3 className="float-left font-bold text-xl">Due Today</h3>

                <h3 className="float-right font-bold text-xl">{(isRating ? "" : currencyFormatter.format(ratedQuote.downPayment))}</h3>
            </div>

            <div className="pt-4 w-9/12 h-10">
                <Button className="btn-continue hover:cursor-pointer float-right p-3 mt-10 w-full" variant="contained" onClick={onPurchasePolicy}>Purchase Policy</Button>
            </div>
        </>;

    }
    return (
        <>
            <div className="container-quote pt-10 w-[85vw] sm:w-[90vw] md:w-[90vw] lg:w-[90vw] xl:w-[60vw] ">
                <Breadcrumbs>
                    <h3 className="text-2xl pb-5 mt-0">Step 5 of 7</h3>
                </Breadcrumbs>
                <div className="grid grid-cols-12 gap-5">
                    <div className="col-span-12 sm:col-span-12: md:col-span-12 lg:col-span-6 xl:col-span-4">
                        <div className="top-1">
                            {isBelowMinimum || isBeyondMaximum ? <></> : <h3 className="text-2xl font-bold">Your Premium</h3>}
                            <span>{isRating || isBelowMinimum || isBeyondMaximum ? "" : currencyFormatter.format(ratedQuote.installments.find(m => m.installmentNumber === 1)?.totalDue ?? 0) + " / mo"}</span>
                            <div className={(isBelowMinimum || isBeyondMaximum ? "" : "mt-6") + "container-review-drivers"}>
                                <h3 className="text-xl font-light">Covered Drivers</h3>

                                <Link to="/people" className="text-sm text-blue-500 mt-2">Edit Drivers</Link>
                                <ReviewDriversList drivers={policy.drivers} />
                            </div>

                            <div className="container-review-vehicles">
                                <h3 className="text-xl font-light">Covered Vehicles</h3>
                                <Link to="/vehicles" className="text-sm text-blue-500 mt-2">Edit Vehicles</Link>
                                <ReviewVehiclesList vehicles={policy.vehicles} />
                            </div>
                        </div>
                    </div>
                    <div className="col-span-12 sm:col-span-12: md:col-span-12 lg:col-span-6 xl:col-span-5">
                        <div className="top-1 sticky">
                            <h3 className="font-bold text-2xl pb-5">Summary</h3>
                            <span className="text-gray-400 text-sm font-medium">Quote Number</span>
                            <br />
                            <span>{isRating ? "" : ratedQuote.policyNumber}</span>
                            <br />
                            <span className="text-gray-400 text-sm font-medium">{isEditEffectiveDate ? "" : "Policy Start Date"}</span>
                            <br />
                            <span>
                                {renderEffectiveDate()}
                            </span>
                            <div className="clear-both" />
                            <span className="text-gray-400 text-sm font-medium">Policy Term:</span>
                            <br />
                            <span>{isRating ? "" : ratedQuote.installments.length + " months"}</span>
                            <br />
                            <p className="pt-2 pb-5">
                                <span onClick={(e) => { isEditEffectiveDate ? isReload ? (() => { })() : onCancelChangeEffectiveDate(e) : setIsEditEffectiveDate(true) }} className={`${isEditEffectiveDate ? " text-red-600" : "text-blue-500"}  hover:underline hover:underline-offset-2 hover:cursor-pointer`}>
                                    {isEditEffectiveDate ? isReload ? "Updating Quote, Please Wait" : "Cancel Start Date Change" : "Change Start Date"}
                                </span>
                            </p>

                            <p className="pt-5 pb-">
                                This quote contains your current policy's coverage.
                            </p>
                            <p className="pb-10 pt-2">
                                <span onClick={() => { navigate("/coverages" + window.location.search) }} className="text-blue-500 hover:underline hover:underline-offset-2 hover:cursor-pointer">Review/Edit Policy Coverages</span>
                            </p>


                            {renderPremiumInfo()}
                        </div>

                    </div>
                </div>
            </div>
            <div className="mb-5 mt-28 p-5 bg-[#e0e1dd]">




                <div className=" m-auto  w-[60vw]">
                    <SecondaryButton onClick={NavigateBack} variant="contained" className="p-2 w-1/6">Back</SecondaryButton>

                </div>
            </div>







            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
                onClick={handleClose}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={isOpenErrorAlert}
                autoHideDuration={6000}
                onClose={handleErrorAlertClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}>
                <Alert onClose={handleErrorAlertClose} severity="error" sx={{ width: '100%' }}>
                    Error occurred requesting additional information. Please refresh the page and try again.
                </Alert>
            </Snackbar>

            <ProcessingModal isShowSpinner={true} isOpen={isRating} message={"We are rating your quote, this may take a moment"} title={"Rating Quote"} onCloseModal={() => { }} />
        </>
    );
}

export default Review;
